/* Measurement-only product Add to Cart attribution context. */
(function () {
  var lastIntentAt = 0;
  var lastIntentKey = '';

  function pushEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
  }

  function safeToken(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'unknown';
  }

  function currentModule(target) {
    if (target && target.closest) {
      var scoped = target.closest('[data-rs-product-delivery="true"]');
      if (scoped) return scoped;
    }
    return document.querySelector('[data-rs-product-delivery="true"]');
  }

  function modulePayload(module) {
    var estimate = module.querySelector('[data-rs-arrive-by="true"]');
    var estimateState = estimate ? safeToken(estimate.getAttribute('data-rs-arrive-by-state') || 'pending') : 'missing';
    return {
      product_handle: module.getAttribute('data-rs-product-handle') || '',
      temperature_bucket: safeToken(module.getAttribute('data-rs-temperature-bucket') || 'unknown'),
      product_type: module.getAttribute('data-rs-product-type') || '',
      conversion_path: safeToken(module.getAttribute('data-rs-conversion-path') || 'cart_checkout'),
      arrive_by_signal_state: 'arrive_by_' + estimateState,
      estimated_arrive_by_bucket: estimate ? safeToken(estimate.getAttribute('data-rs-arrive-by-window') || 'pending') : 'missing',
      experiment_id: module.getAttribute('data-rs-experiment-id') || 'P1-PRODUCT-ARRIVE-BY',
      cta_location: 'product_form'
    };
  }

  function setContext(payload) {
    window.RS_PRODUCT_CTA_CONTEXT = payload;
  }

  function isCartForm(form) {
    if (!form) return false;
    if (form.matches && form.matches('form[action*="/cart/add"]')) return true;
    return Boolean(form.closest && form.closest('product-form'));
  }

  function cartFormFromButton(button) {
    if (!button || !button.closest) return null;
    return button.closest('form[action*="/cart/add"]') || button.closest('product-form form') || button.closest('product-form');
  }

  function isDisabled(button) {
    if (!button) return true;
    if (button.disabled) return true;
    if (button.getAttribute && button.getAttribute('aria-disabled') === 'true') return true;
    return Boolean(button.hasAttribute && button.hasAttribute('disabled'));
  }

  function pushAddIntent(target) {
    var module = currentModule(target);
    if (!module) return;
    var payload = modulePayload(module);
    var now = Date.now();
    var key = payload.product_handle + ':' + payload.estimated_arrive_by_bucket + ':' + payload.conversion_path;
    if (key === lastIntentKey && now - lastIntentAt < 1000) return;
    lastIntentKey = key;
    lastIntentAt = now;
    setContext(payload);
    pushEvent('product_cta_add_intent', payload);
  }

  function primeContext() {
    var module = currentModule();
    if (!module) return;
    setContext(modulePayload(module));
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('.product-form__submit, button[name="add"], button[type="submit"]');
    if (!button || isDisabled(button)) return;
    var form = cartFormFromButton(button);
    if (!isCartForm(form)) return;
    pushAddIntent(button);
  }, true);

  document.addEventListener('submit', function (event) {
    if (!isCartForm(event.target)) return;
    pushAddIntent(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeContext, { once: true });
  } else {
    primeContext();
  }
}());
